export default __webpack_public_path__ + "1fe79bc19776a855a02611cb73a71ba5.png";